import React, { useState } from 'react'
import {
  DateInput,
  ImageUpload,
  ModalWrapper,
  SelectField,
  StyledButton,
  TextFields,
} from '../../../../../../components'
import { Divider, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { baseURL, getImageURL, urls } from '../../../../../../shared/config'
import { toast } from 'react-toastify'
import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import axios from 'axios'

const typeOptions = [
  { label: 'Admin', value: 'Admin' },
  { label: 'Staff', value: 'Staff' },
  { label: 'Driver', value: 'Driver' },
]
const genderOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
]
const formatDate = (dateString) => {
  const [year, month, day] = dateString.split(/-|T/)
  return `${year}-${month}-${day}`
}
export const EditEmployee = ({ open, handleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  const employee_ID = useSelector((state) => state.global.employee_ID)
  const dispatch = useDispatch()
  const initialValues = useState({
    name: '',
    type: '',
    contactNumber: '',
    gender: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    employeeImage: '',
    email: '',
    salary: '',
    joiningDate: '',
  })
  React.useEffect(() => {
    if (data) {
      formik.setValues({
        name: data?.employee_name,
        contactNumber: data.employee_contact_number,
        gender: data.employee_gender,
        address1: data.employee_address,
        address2: data.employee_address_two,
        city: data.employee_city,
        state: data.employee_state,
        zipCode: data.employee_pincode ? String(data.employee_pincode) : '',
        employeeImage: data?.employee_avatar || '',
        email: data.employee_email,
        salary: data?.employee_salary,
        joiningDate: data?.employee_joining_date ? formatDate(data?.employee_joining_date) : '',
        employee_dob: data?.employee_dob ? formatDate(data?.employee_dob) : '',
      })
    }
  }, [data])

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    // type: Yup.string().required('Type is required'),
    contactNumber: Yup.string()
      .required('Phone Number is required')
      .matches(/^\d{10}$/, 'Invalid phone number'),
  })
  const [image, setImage] = useState()
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    setImage(selectedFile)
  }
  const handleSubmit = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        if (formik.values.zipCode) {
          if (formik.values.zipCode.length !== 6) {
            toast.error('Zipcode must be 6 digits!')
            dispatch(setLoader(false))
            return
          }
        }
        let newAvatarUrl = null

        if (image instanceof File) {
          try {
            newAvatarUrl = await uploadImageToS3(image, 'employee')
            // newAvatarUrl is now: https://bucket.s3.../timestamp-filename.jpg
          } catch (uploadErr) {
            console.error('Image upload failed:', uploadErr)
            toast.error('Failed to upload new profile picture. Please try again.')
            return // ← important: stop if upload fails
          }
        }
        const responseBody = {
          employee_id: employee_ID,
          employee_name: formik.values.name,
          employee_email: formik.values.email,
          employee_gender: formik.values.gender,
          employee_contact_number: formik.values.contactNumber,
          ...(newAvatarUrl
            ? { employee_avatar: newAvatarUrl }
            : formik.values.employeeImage || data?.employee_avatar
              ? { employee_avatar: formik.values.employeeImage || data?.employee_avatar }
              : {}),
          ...(formik.values.address1 ? { employee_address: formik.values.address1 } : {}),
          ...(formik.values.address2 ? { employee_address_two: formik.values.address2 } : {}),
          employee_city: formik.values.city,
          employee_state: formik.values.state,
          employee_pincode: formik.values.zipCode || '',
          employee_type: formik.values.type || data?.employee_type,

          employee_salary: formik.values.salary,
          employee_joining_date: formik.values.joiningDate,
          employee_dob: formik.values.employee_dob,
        }
        axios
          .patch(`${baseURL}${urls.EMPLOYEE_PATCH}`, responseBody)
          .then(() => {
            toast.success('Record Updated Successfully!')
            dispatch(setLoader(false))
            dispatch(setRefreshPage(true))
            handleClose()
          })
          .catch((error) => {
            console.error('Error updating school info:', error)
            toast.error('Error occurred while submitting')
            dispatch(setLoader(false))
          })
      })
      .catch(() => {
        console.log('errors', formik.errors)
        toast.error('Please fix the validation errors before submitting.')
        dispatch(setLoader(false))
      })
  }

  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      title={'Edit Employee'}
      width={'fit-content'}
    >
      <div className="add-employee">
        <Typography mb={2} className="form-heading">
          Personal Information
        </Typography>
        <div className="emp-det-head">
          <ImageUpload
            selectedImage={image ? URL.createObjectURL(image) : data && data?.employee_avatar}
            onFileChange={handleFileChange}
          />
        </div>
        <div className="text-fields">
          <TextFields
            width={'50%'}
            label={'Name'}
            name={'name'}
            value={formik.values.name}
            required
            onChange={formik.handleChange}
          />
          <SelectField
            required
            placeholder={data?.employee_type || 'Select'}
            label={'Type'}
            options={typeOptions}
            width={'100%'}
            containerWidth={'46%'}
            value={formik.values.type}
            onChange={(value) => formik.setFieldValue('type', value)}
            name="type"
          />
        </div>
        <div className="text-fields">
          <TextFields
            width={'50%'}
            required
            label={'Contact Number'}
            readOnly
            value={formik.values.contactNumber}
            name="contactNumber"
          />
          <SelectField
            width={'100%'}
            label={'Gender'}
            options={genderOptions}
            value={formik.values.gender}
            required
            onChange={(value) => formik.setFieldValue('gender', value)}
          />
        </div>
        <DateInput
          required
          label={'Date of Birth'}
          value={formik.values.employee_dob}
          name={'employee_dob'}
          onChange={formik.handleChange}
        />
        <TextFields
          label={'Email'}
          name={'email'}
          value={formik.values.email}
          required
          onChange={formik.handleChange}
          disabled={true}
        />
        <Divider />
        <Typography mt={2} mb={2} className="form-heading">
          Other Information
        </Typography>
        <div className="text-fields">
          <TextFields
            width={'50%'}
            name={'salary'}
            label={'Salary'}
            value={formik.values.salary}
            required
            onChange={formik.handleChange}
          />
          <DateInput
            label={'Date of Joining'}
            value={formik.values.joiningDate}
            name={'joiningDate'}
            required
            onChange={formik.handleChange}
          />
        </div>
        <div className="text-fields">
          <TextFields
            width={'50%'}
            name={'address1'}
            label={'Address'}
            value={formik.values.address1}
            onChange={formik.handleChange}
          />
          <TextFields
            name={'address2'}
            label={'Address 2'}
            value={formik.values.address2}
            onChange={formik.handleChange}
          />
        </div>
        <div className="text-fields">
          <TextFields
            name={'city'}
            label={'City'}
            width={'150px'}
            value={formik.values.city}
            onChange={formik.handleChange}
          />
          <TextFields
            name={'state'}
            label={'State'}
            width={'120px'}
            value={formik.values.state}
            onChange={formik.handleChange}
          />
          <TextFields
            name={'zipCode'}
            label={'Zip Code'}
            width={'120px'}
            value={formik.values.zipCode}
            onChange={handleInputChange('zipCode')}
          />
        </div>
        <div className="add-employee-btns">
          <div className="in-a-row">
            <Typography onClick={handleClose} className="cancel-btn">
              Cancel
            </Typography>
            <StyledButton onClick={handleSubmit}>Update</StyledButton>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
